var __TEMP__ = require('./_baseSet.js');var baseSet = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseZipObject.js');var baseZipObject = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This method is like `_.zipObject` except that it supports property paths.
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
 */
function zipObjectDeep(props, values) {
  return baseZipObject(props || [], values || [], baseSet);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = zipObjectDeep;
